import jstz from 'jstz';

export function getBrowserTimezone(): string {
  return jstz.determine().name();
}
